// extracted by mini-css-extract-plugin
export default {"wrapper":"AddressCard_wrapper__2GPMt","info":"AddressCard_info__I8ar-","wrapper-hover":"AddressCard_wrapper-hover__Mru+G"};